
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface NavLinkProps {
  to: string;
  isActive: boolean;
  onClick?: () => void;
  children: React.ReactNode;
}

export function NavLink({ to, isActive, onClick, children }: NavLinkProps) {
  return (
    <Link 
      to={to} 
      className={cn(
        "px-3 py-2 text-sm font-medium rounded-md transition-colors",
        isActive 
          ? "bg-primary/10 text-primary hover:bg-primary/20" 
          : "hover:bg-secondary/50"
      )}
      onClick={onClick}
      aria-current={isActive ? 'page' : undefined}
    >
      {children}
    </Link>
  );
}
